import {Editor} from '@tiptap/core';

import {generateShortcutLabel, getCommandKey, KeyModifiers} from 'common/util/keyboard';

const COMMAND_KEY = getCommandKey();
const SHORTCUT_LABEL_MODIFIERS = [COMMAND_KEY, KeyModifiers.Alt];

export enum BubbleMenuOverflowActions {
  Code = `code`,
  Divider = `divider`,
  OrderedList = `orderedList`,
  Quote = `quote`,
  Underline = `underline`,
}

export enum OverflowType {
  Other = `other`,
  Text = `text`,
}

export enum TipTapFormats {
  BlockQuote = `blockquote`,
  Bold = `bold`,
  BulletList = `bulletList`,
  Code = `code`,
  Heading = `heading`,
  Italic = `italic`,
  OrderedList = `orderedList`,
  Paragraph = `paragraph`,
  StrikeThrough = `strike`,
  Link = `link`,
  Underline = `underline`,
  Highlight = `highlight`,
}

export const LINE_FORMAT_SECTION_ITEMS = [
  {
    value: `header-two`,
    icon: `title`,
    label: `Title`,
    tooltip: {
      text: generateShortcutLabel(`2`, {forMarkdown: true, modifiers: SHORTCUT_LABEL_MODIFIERS}),
    },
    isSelected: (editor: Editor) => editor.isActive(TipTapFormats.Heading, {level: 2}),
    onClick: (editor: Editor) => editor.chain().focus().toggleHeading({level: 2}).run(),
  },
  {
    value: `header-three`,
    icon: `subtitle`,
    label: `Subtitle`,
    tooltip: {
      text: generateShortcutLabel(`3`, {forMarkdown: true, modifiers: SHORTCUT_LABEL_MODIFIERS}),
    },
    isSelected: (editor: Editor) => editor.isActive(TipTapFormats.Heading, {level: 3}),
    onClick: (editor: Editor) => editor.chain().focus().toggleHeading({level: 3}).run(),
  },
  {
    value: `text`,
    icon: `text`,
    label: `Text`,
    tooltip: {
      text: generateShortcutLabel(`0`, {forMarkdown: true, modifiers: SHORTCUT_LABEL_MODIFIERS}),
    },
    isSelected: (editor: Editor) => editor.isActive(TipTapFormats.Paragraph),
    onClick: (editor: Editor) => editor.chain().focus().clearNodes().run(),
  },
];

export const OVERFLOW_ACTION_SECTION = [
  // first section
  [
    {
      value: BubbleMenuOverflowActions.OrderedList,
      icon: `numbered-list`,
      label: `Ordered List`,
      format: TipTapFormats.OrderedList,
      isDisabled: () => false,
      isSelected: (editor: Editor) => editor.isActive(TipTapFormats.OrderedList),
      onClick: (editor: Editor) => editor.chain().focus().toggleOrderedList().run(),
      tooltip: {
        text: generateShortcutLabel(`5`, {forMarkdown: true, modifiers: SHORTCUT_LABEL_MODIFIERS}),
      },
    },
    {
      value: BubbleMenuOverflowActions.Quote,
      icon: `blockquote`,
      label: `Block Quote`,
      format: TipTapFormats.BlockQuote,
      isDisabled: (editor: Editor) =>
        editor.isActive(TipTapFormats.BulletList) || editor.isActive(TipTapFormats.OrderedList),
      onClick: (editor: Editor) => editor.chain().focus().toggleBlockquote().run(),
      isSelected: (editor: Editor) => editor.isActive(TipTapFormats.BlockQuote),
      tooltip: {
        text: generateShortcutLabel(`6`, {forMarkdown: true, modifiers: SHORTCUT_LABEL_MODIFIERS}),
      },
    },
    {
      value: BubbleMenuOverflowActions.Divider,
      icon: `text-dash`,
      label: `Divider Line`,
      format: null,
      isDisabled: () => false,
      isSelected: () => false,
      onClick: (editor: Editor) => editor.chain().focus().setHorizontalRule().run(),
      tooltip: {
        text: generateShortcutLabel(`7`, {forMarkdown: true, modifiers: SHORTCUT_LABEL_MODIFIERS}),
      },
    },
  ],
  // second section
  [
    {
      value: BubbleMenuOverflowActions.Underline,
      icon: `underline`,
      label: `Underline`,
      format: TipTapFormats.Underline,
      isDisabled: () => false,
      isSelected: (editor: Editor) => editor.isActive(TipTapFormats.Underline),
      onClick: (editor: Editor) => editor.chain().focus().toggleUnderline().run(),
      tooltip: {
        text: generateShortcutLabel(`U`, {forMarkdown: true, modifiers: [COMMAND_KEY]}),
      },
    },
    {
      value: BubbleMenuOverflowActions.Code,
      icon: `coding`,
      label: `Code`,
      format: TipTapFormats.Code,
      isDisabled: () => false,
      isSelected: (editor: Editor) => editor.isActive(TipTapFormats.Code),
      onClick: (editor: Editor) => editor.chain().focus().toggleCode().run(),
      tooltip: {
        text: generateShortcutLabel(`8`, {forMarkdown: true, modifiers: SHORTCUT_LABEL_MODIFIERS}),
      },
    },
  ],
];

export enum FocusLocation {
  End = `end`,
}
